import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PrimaryButton from '../ReactComponent/PrimaryButton';
import { ErrorMessage, Icon } from '../ReactComponent/RenderField/css';
import Quotes from '../../assets/icons/Quotes.svg';
import Track from '../../assets/icons/Track.svg';
import Shipment from '../../assets/icons/Shipment.svg';
import Error from '../../assets/icons/Error.svg';
import { routes } from '../../utils/constants';
import {
  Container,
  Title,
  BodyContainer,
  TabContainer,
  Tab,
  TabText,
  Form,
  FieldWrapper,
} from './css';
import { validateForm } from '../TrackShipment/validation';

const HomePageHeader = ({ fields }) => {
  const [trackNumbers, setTrackNumbers] = useState('');
  const [error, setError] = useState('');

  // If there are field validation errors, show error message and disable the button
  const handleInput = (input) => {
    const fieldValidation = validateForm({
      shipmentNumbers: input.trim(),
    });
    if (fieldValidation.shipmentNumbers) {
      setError(fieldValidation.shipmentNumbers);
    } else {
      setError('');
    }

    setTrackNumbers(input);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedTrackNumbers = trackNumbers.trim();

    // If it's not an empty string
    if (trimmedTrackNumbers) {
      // Redirect and pass in the URL to the track shipments number
      window.location.href = `${routes.trackShipments
      }?homeProbillNumbers=${
        trimmedTrackNumbers}`;
    } else {
      window.location.href = fields.link2.value.href;
    }
  };

  return (
    <Container $img={fields.image.value.src} alt={fields.image.value.alt}>
      <Title>{fields.heading.value}</Title>
      <BodyContainer>
        <TabContainer>
          <Tab onClick={() => {
            window.location.href = fields.link1.value.href;
            return window.location.href;
          }}
          >
            <img src={Quotes} alt="Quotes" />
            <TabText>{fields.link1.value.text}</TabText>
          </Tab>
        </TabContainer>
        <Tab onClick={() => {
          window.location.href = fields.link2.value.href;
          return window.location.href;
        }}
        >
          <img src={Track} alt="Track" />
          <TabText>{fields.link2.value.text}</TabText>
        </Tab>
        <TabContainer>
          <Tab onClick={() => {
            window.location.href = fields.link3.value.href;
            return window.location.href;
          }}
          >
            <img src={Shipment} alt="Shipment" />
            <TabText>{fields.link3.value.text}</TabText>
          </Tab>
        </TabContainer>
        <Form onSubmit={handleSubmit}>
          <FieldWrapper>
            <input
              value={trackNumbers}
              placeholder={fields.inputPlaceholder.value}
              className={error && 'error'}
              onChange={(event) => handleInput(event.target.value)}
            />
            {error && (
              <ErrorMessage>
                <Icon src={Error} alt={error} />
                {error}
              </ErrorMessage>
            )}
          </FieldWrapper>

          <PrimaryButton disabled={!!error} iconRightArrow onClick={(e) => handleSubmit(e)}>
            {fields.link2.value.text}
          </PrimaryButton>
        </Form>
      </BodyContainer>
    </Container>
  );
};

HomePageHeader.propTypes = {
  fields: PropTypes.shape({
    heading: PropTypes.object,
    image: PropTypes.shape({
      value: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
      }),
    }),
    link1: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
    link2: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
    link3: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
    inputPlaceholder: PropTypes.object,
  }),
};

export default HomePageHeader;
